


































import { Component, Vue } from 'vue-property-decorator';
import { KycOrgConfig } from '@/api/auth';
import { sendLog } from '@/api/client-logs';
import PageHeader from '@/components/PageHeader.vue';
import FooterButton from '@/components/FooterButton.vue';
import RedirectMode from '@/resources/enum/RedirectMode';
import { ErrorCode } from '@/resources/error/ErrorCode';

@Component({
  components: {
    PageHeader,
    FooterButton
  }
})
export default class Parts extends Vue {
  private timerIdAuto: number = -1;
  private timerIdReset: number = -1;

  private get isAutoCalled(): string {
    return this.$store.getters['completion/isAutoCalled'];
  }

  private get isRedirected(): string {
    return this.$store.getters['completion/isRedirected'];
  }

  private get redirectMode(): RedirectMode {
    const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];
    return kycOrgConfig.redirectMode;
  }

  private get redirectURL(): string {
    const kycRequestRedirectURL: string = this.$store.getters['auth/kycRequestRedirectURL'];
    const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];
    const redirectURL: string = kycRequestRedirectURL || kycOrgConfig.redirectURL;
    if (redirectURL.match(/^\s*javascript:/) !== null) return '';
    return redirectURL;
  }

  private get isPassVaccine(): boolean {
    return this.$store.getters['auth/isPassVaccine'];
  }

  private get isShowIcon(): boolean {
    if (this.isPassVaccine) return true;
    return !this.redirectURL;
  }

  private get header(): string {
    let key: string = '';
    if (this.isPassVaccine) {
      key = 'passVaccine.completion.header';
    } else if (this.$store.getters['auth/isOnlyGpGeneral']) {
      if (this.redirectURL) {
        key = 'applicationCompletion.gpdoc.redirectURL.Header';
      } else {
        key = 'applicationCompletion.gpdoc.notRedirectURL.Header';
      }
    } else {
      if (this.redirectURL) {
        key = 'applicationCompletion.normal.redirectURL.Header';
      } else {
        key = 'applicationCompletion.normal.notRedirectURL.Header';
      }
    }
    return this.$t(key) as string;
  }

  private get description1(): string[] {
    let key: string = '';
    if (this.isPassVaccine) {
      key = 'passVaccine.completion.description1';
    } else if (this.$store.getters['auth/isOnlyGpGeneral']) {
      if (this.redirectURL) {
        key = 'applicationCompletion.gpdoc.redirectURL.description1';
      } else {
        key = 'applicationCompletion.gpdoc.notRedirectURL.description1';
      }
    } else {
      if (this.redirectURL) {
        key = 'applicationCompletion.normal.redirectURL.description1';
      } else {
        key = 'applicationCompletion.normal.notRedirectURL.description1';
      }
    }
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get description2(): string[] {
    let key: string = '';
    if (this.isPassVaccine) {
      key = 'passVaccine.completion.description2';
    } else if (this.$store.getters['auth/isOnlyGpGeneral']) {
      if (this.redirectURL) {
        key = 'applicationCompletion.gpdoc.redirectURL.description2';
      } else {
        key = 'applicationCompletion.gpdoc.notRedirectURL.description2';
      }
    } else {
      if (this.redirectURL) {
        key = 'applicationCompletion.normal.redirectURL.description2';
      } else {
        key = 'applicationCompletion.normal.notRedirectURL.description2';
      }
    }
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get next(): string[] {
    let key: string = '';
    if (this.isPassVaccine) {
      key = 'passVaccine.completion.next';
    } else {
      key = 'applicationCompletion.next';
    }
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get isAutoRedirect(): boolean {
    if (!this.redirectURL) return false;
    if (this.isRedirected) return false;
    if (this.redirectMode === RedirectMode.Manual) return false;
    return true;
  }

  async mounted(): Promise<void> {
    if (this.isAutoRedirect && !this.isAutoCalled) {
      // 自動リダイレクト
      this.timerIdAuto = window.setTimeout((): void => {
        this.redirect(true);
      }, 1000);
    } else if (this.redirectMode !== RedirectMode.AutoOnce) {
      // 一定時間経過後にリダイレクトの再許可
      this.resetRedirect(1000);
    } else if (this.isRedirected) {
      // リダイレクト済みで再びリダイレクトができない場合はエラーページへ飛ばす
      const code: ErrorCode = ErrorCode.KYCRequestInvalidStatus;
      this.$router.push({ name: 'application-error', params: { code } });
    }
  }

  beforeDestroy(): void {
    window.clearTimeout(this.timerIdAuto);
    window.clearTimeout(this.timerIdReset);
  }

  private async redirect(isAutomaticPageTransition: boolean): Promise<void> {
    if (this.isRedirected) return;
    this.$store.commit('completion/setAutoCalled', true);
    this.$store.commit('completion/setRedirected', true);

    // リダイレクト直前にログを送信
    const isLogSuccess: boolean = await sendLog({
      level: 'INFO',
      kind: 'application_completed_redirect',
      fields: [isAutomaticPageTransition ? 'timeout' : 'button']
    });

    if (isLogSuccess) {
      // 少し経ったらリダイレクトの再許可
      this.resetRedirect(2000);
      // ページ遷移
      window.location.href = this.redirectURL;
    } else {
      // ログ送信に失敗したらページ遷移を無かったことにする
      await new Promise(resolve => setTimeout(resolve, 500));
      this.$store.commit('completion/setRedirected', false);
    }
  }

  private async resetRedirect(time: number): Promise<void> {
    if (!this.isRedirected) return;
    if (this.redirectMode === RedirectMode.AutoOnce) return;
    await new Promise(resolve => setTimeout(resolve, time));
    this.$store.commit('completion/setRedirected', false);
  }

  private onNext(): void {
    // 手動リダイレクト
    window.clearTimeout(this.timerIdAuto);
    window.clearTimeout(this.timerIdReset);
    this.redirect(false);
  }
}
